var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_23213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53834 1.50987C7.70914 1.09922 8.29086 1.09922 8.46166 1.50987L9.99874 5.20546C10.0707 5.37858 10.2336 5.49686 10.4204 5.51185L14.4102 5.8317C14.8535 5.86724 15.0332 6.42049 14.6955 6.70983L11.6557 9.31368C11.5133 9.43566 11.4512 9.62705 11.4947 9.80943L12.4234 13.7027C12.5265 14.1353 12.0559 14.4772 11.6764 14.2454L8.26063 12.1591C8.10062 12.0614 7.89938 12.0614 7.73937 12.1591L4.32363 14.2454C3.94408 14.4772 3.47345 14.1353 3.57665 13.7027L4.50534 9.80943C4.54884 9.62705 4.48665 9.43566 4.34426 9.31368L1.30453 6.70983C0.966758 6.4205 1.14652 5.86724 1.58985 5.8317L5.57955 5.51185C5.76645 5.49686 5.92925 5.37858 6.00126 5.20546L7.53834 1.50987Z",
    fill: "#FEC84B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_23213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfilled);
export default __webpack_public_path__ + "static/media/starfilled.aaf905fbfc9a9525f7d2beb0e9354eb1.svg";
export { ForwardRef as ReactComponent };